import { Injectable } from '@angular/core';

const appTokenKey:string = "token";

@Injectable({
    providedIn: 'root'
})
export class StorageService {

    constructor() { }

    setObject(item: string, objectItem: any){
        localStorage.setItem(item, JSON.stringify(objectItem));
    }

    getObject(item: string): any{
        let itemObjeto: any = localStorage.getItem(item);
        if(itemObjeto) itemObjeto = JSON.parse(itemObjeto);
        return itemObjeto || [];
    }

    removeObject(item: string) {
        localStorage.removeItem(item);
    }

    inserirTokenAplicacao(token: string): void {
        localStorage.setItem(appTokenKey, token);
    };

    limparTokenAplicacao(): void {
        localStorage.removeItem(appTokenKey);
    };

    buscarTokenAplicacao(): string {
        return localStorage.getItem(appTokenKey);
    };

}
